(function () {
  // function for product page

  if (
    document.querySelector(
      ".featured-collection--carousel .shopify-product-reviews-badge"
    )
  ) {
    window.addEventListener("load", function () {
      var badgeInterval = setInterval(function () {
        if (
          document.querySelectorAll(".featured-collection--carousel .spr-badge")
            .length > 0
        ) {
          theme.window.trigger("resize.FeaturedCollections");
          clearInterval(badgeInterval);
          badgeInterval = null;
        }
      }, 500);
    });
  }

  // accordion
  var accordions = document.querySelectorAll(".accordion__item");

  // Iterate through each accordion element
  accordions.forEach(function (accordion) {
    // Add a click event listener to each accordion
    accordion.addEventListener("click", function () {
      // Toggle the "is-active" class for the clicked accordion
      if (this.classList.contains("is-active")) {
        this.classList.remove("is-active");
      } else {
        this.classList.add("is-active");
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    var elem = document.querySelector(".product-page--grid");
    var flkty = new Flickity(elem, {
      // options
      cellAlign: "left",
      prevNextButtons: false,
      pageDots: false,
      contain: true,
      wrapAround: true,
      draggable: true,
      hash: true,
    });

    var externalNavButtons = document.querySelectorAll(
      ".product-media--wrapper-as-for"
    );

    externalNavButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var slideIndex = parseInt(this.getAttribute("data-slide"), 10);
        flkty.select(slideIndex);
      });
    });
  });
})();
